import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';
import { GaService } from 'src/app/core/helpers/ga.service';

@Component({
  selector: 'loyaltic-code-entry',
  templateUrl: './code-entry.component.html',
  styleUrls: ['./code-entry.component.scss']
})
export class CodeEntryComponent implements OnInit {
  userId: any;
  code: any
  constructor( private coreService: CoreService,private authService: AuthService,public gaService: GaService, private toast: ToastrService, private translate: TranslateService) {
    this.userId = authService.getUserId();
  }

  ngOnInit() {
  }

  onSubmit(formRef) {

    const body = {
      UserId: this.userId,
      Code: this.code
    };

    // this.coreService.checkCode(body).then((inviteResponse: any) => {
    //   formRef.submitted = false;
    //   this.resetForm();
    //   this.gaService.emitEvent('redeem_reward', 'code_redeemed');

    //   this.coreService.pointsEmitter.emit(true);
    //   // this.coreService.earnedPointsEmitter.emit(true);
    //   const successMessage = this.translate.instant('code-approved-successfully');
    //   this.toast.success(successMessage, ' ');
    // }).catch((errorResponse: any) => {
    //   const errorMessage = this.translate.instant(errorResponse.error.messageKey);
    //   this.resetForm();
    //   this.toast.error(errorMessage, 'Error');
    //   return;
    // });
  }

  resetForm() {
    this.code = undefined;

  }

}
